<template>
    <div id="app-page">
        <router-view></router-view>
    </div>
</template>

<script>
    import axios from "axios";
    import {mapMutations,mapState} from "vuex"
    import {getToken,removeToken} from "./plugins/auth";
    export default {
        name: "App",
        data(){
          return {
              connexion: null
          }
        },
        computed:{
            ...mapState({
                token: (state) => state.user.token
            })
        },
        created() {
            axios.interceptors.response.use(undefined, (err) => {
                return new Promise(() => {
                    console.log(err.response.status)
                    if (err.response.status === 401) {
                        const h = this.$createElement;
                        this.$notify.warning({
                            title: 'Login',
                            message: h('i', { style: 'color: teal' }, 'Email ou mot de passe incorrect'),
                            duration: 2000
                        });
                        this.setLoading(false)
                    }else {
                        // window.location.href = '/';
                    }
                    throw err;
                });
            });

            // this.setToken(getToken() ?? null)
            this.setToken(getToken() || null);
            if(getToken()){
                console.log('app connected')
            }else {
            }
        },
        methods:{
            ...mapMutations('user',['setToken']),
            ...mapMutations('other',['setLoading'])
        }
    }
</script>

<style scoped>

</style>